// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export {
  listMongoUserDefinitions,
  deleteMongoUserDefinition,
  createUpdateMongoUserDefinition,
  getMongoUserDefinition,
  listMongoRoleDefinitions,
  deleteMongoRoleDefinition,
  createUpdateMongoRoleDefinition,
  getMongoRoleDefinition,
  retrieveContinuousBackupInformation,
  listMongoDBCollections,
  deleteMongoDBCollection,
  createUpdateMongoDBCollection,
  getMongoDBCollection,
  listMongoDBDatabases,
  deleteMongoDBDatabase,
  createUpdateMongoDBDatabase,
  getMongoDBDatabase,
  migrateMongoDBCollectionToManualThroughput,
  migrateMongoDBCollectionToAutoscale,
  updateMongoDBCollectionThroughput,
  getMongoDBCollectionThroughput,
  migrateMongoDBDatabaseToManualThroughput,
  migrateMongoDBDatabaseToAutoscale,
  updateMongoDBDatabaseThroughput,
  getMongoDBDatabaseThroughput,
} from "./operations.js";
export type {
  MongoDBResourcesListMongoUserDefinitionsOptionalParams,
  MongoDBResourcesDeleteMongoUserDefinitionOptionalParams,
  MongoDBResourcesCreateUpdateMongoUserDefinitionOptionalParams,
  MongoDBResourcesGetMongoUserDefinitionOptionalParams,
  MongoDBResourcesListMongoRoleDefinitionsOptionalParams,
  MongoDBResourcesDeleteMongoRoleDefinitionOptionalParams,
  MongoDBResourcesCreateUpdateMongoRoleDefinitionOptionalParams,
  MongoDBResourcesGetMongoRoleDefinitionOptionalParams,
  MongoDBResourcesRetrieveContinuousBackupInformationOptionalParams,
  MongoDBResourcesListMongoDBCollectionsOptionalParams,
  MongoDBResourcesDeleteMongoDBCollectionOptionalParams,
  MongoDBResourcesCreateUpdateMongoDBCollectionOptionalParams,
  MongoDBResourcesGetMongoDBCollectionOptionalParams,
  MongoDBResourcesListMongoDBDatabasesOptionalParams,
  MongoDBResourcesDeleteMongoDBDatabaseOptionalParams,
  MongoDBResourcesCreateUpdateMongoDBDatabaseOptionalParams,
  MongoDBResourcesGetMongoDBDatabaseOptionalParams,
  MongoDBResourcesMigrateMongoDBCollectionToManualThroughputOptionalParams,
  MongoDBResourcesMigrateMongoDBCollectionToAutoscaleOptionalParams,
  MongoDBResourcesUpdateMongoDBCollectionThroughputOptionalParams,
  MongoDBResourcesGetMongoDBCollectionThroughputOptionalParams,
  MongoDBResourcesMigrateMongoDBDatabaseToManualThroughputOptionalParams,
  MongoDBResourcesMigrateMongoDBDatabaseToAutoscaleOptionalParams,
  MongoDBResourcesUpdateMongoDBDatabaseThroughputOptionalParams,
  MongoDBResourcesGetMongoDBDatabaseThroughputOptionalParams,
} from "./options.js";
